var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"domresize",rawName:"v-domresize"}],on:{"domresize":_vm.resize}},[(!_vm.ready)?_c('LayoutState',{style:(`opacity:${_vm.ready?0:1};`)}):_vm._e(),_c('transition',{attrs:{"enter-active-class":"fade-enter-active","leave-active-class":"fade-leave-active"}},[(_vm.ready)?_c('Layout'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }